import React, { useState } from 'react';
import type { DescriptionElement } from 'models/forms/formElements/DescriptionElement';

type Props = {
  element: DescriptionElement;
  isEditing: boolean;
  onUpdate: (updatedElement: DescriptionElement) => void;
  isDisabled?: boolean;
};

const DescriptionElementComponent: React.FC<Props> = ({ element, isEditing, onUpdate, isDisabled }) => {
  const [name, setName] = useState(element.name);
  const [text, setText] = useState(element.value || '');
  const [placeholder, setPlaceholder] = useState(element.placeholder || '');

  if (isEditing) {
    return (
      <div className="space-y-3">
        <div>
          <p className="mb-1 text-sm text-gray-700">Label</p>
          <input
            type="text"
            value={name}
            onChange={(e) => {
              const next = e.target.value;
              setName(next);
              onUpdate({ ...element, name: next });
            }}
            className="block w-full px-3 py-2 border border-gray-300 rounded"
          />
        </div>

        <div>
          <p className="mb-1 text-sm text-gray-700">Description text</p>
          <textarea
            value={text}
            onChange={(e) => {
              const next = e.target.value;
              setText(next);
              onUpdate({ ...element, value: next });
            }}
            className="block w-full px-3 py-2 border border-gray-300 rounded min-h-[90px]"
          />
        </div>

        <div>
          <p className="mb-1 text-sm text-gray-700">Placeholder</p>
          <input
            type="text"
            value={placeholder}
            onChange={(e) => {
              const next = e.target.value;
              setPlaceholder(next);
              onUpdate({ ...element, placeholder: next });
            }}
            className="block w-full px-3 py-2 border border-gray-300 rounded"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-2.5">
      <div className="block mb-1.5 font-medium text-gray-700">
        {element.name}{element.isRequired ? ' *' : ''}
      </div>
      <div className="text-sm text-gray-700 whitespace-pre-wrap">
        {element.value || ''}
      </div>
    </div>
  );
};

export default DescriptionElementComponent;
